import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../utils/common.constants';

@Injectable()
export class PartnersService { 
  constructor(private http: HttpClient) {
  }
 
  saveFinance(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/partner/finance/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getFinanceById(financeId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/partner/practitioner/' + financeId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  searchFinance(finance, startIndex) {
    return this.http.post(CommonConstants.env + 'api/partner/finance',finance);
     //+ '?start=' + startIndex + '&size='
     // + CommonConstants.PAGINATION_SIZE, practitioner)
  }

  errorHandler(error: any): void {
    throwError(error);
  };

  
  saveLogistics(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/partner/logistics/create', saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  searchLogistics(logistics, startIndex) {
    return this.http.post(CommonConstants.env + 'api/partner/logistics',logistics);
    // + '?start=' + startIndex + '&size='
      //+ CommonConstants.PAGINATION_SIZE, logistics) 
     // return this.http.get(CommonConstants.env + 'api/partner/logistics');
  }
  saveInsurance(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/partner/insurance/create', saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  searchInsurance(insurance, startIndex) {
    return this.http.post(CommonConstants.env + 'api/partner/insurance',insurance);
    // + '?start=' + startIndex + '&size='
      //+ CommonConstants.PAGINATION_SIZE, logistics) 
     // return this.http.get(CommonConstants.env + 'api/partner/logistics');
  }
  
}
